export class Dragable {
    constructor(element, targetElement, resizable = false, edges = null, minSize = { width: 250, height: 50 }, zIndex = 10002000) {
        this.state = {
            initialPosition: [0, 0]
        }
        this.resizable = resizable
        this.edges = edges
        this.element = element
        this.minSize = minSize;
        this.targetElement = targetElement
        this.zIndex = zIndex
        this.init()
    }

    init() {
        const [x, y] = this.initialPosition
        this.element.setAttribute('data-x', x)
        this.element.setAttribute('data-y', y)
        this.setCoordinates(this.element, x, y)
        this.element.style.position = 'absolute';
        this.element.style.zIndex = this.zIndex;
        this.element.style.maxHeight = '95vh';
        if (this.element.nodeType) document.body.appendChild(this.element)
        else document.body.innerHTML = this.element
        this.setDragable()
    }

    setDragable() {
        try {
            this.interactable = interact(this.element)
                .draggable({
                    modifiers: [
                        interact.modifiers.restrict({
                            restriction: 'parent', // Ограничение перемещения внутри родительского элемента
                            endOnly: true
                        })
                    ],
                    allowFrom: this.targetElement || null,
                    // enable inertial throwing
                    inertia: true,
                    // keep the element within the area of it's parent
                    // enable autoScroll
                    autoScroll: true,
                    // call this function on every dragmove event
                    modifiers: [
                        interact.modifiers.restrictRect({
                            restriction: 'parent',
                            endOnly: true
                        })
                    ],
                    onmove: this.dragMoveListener.bind(this),
                    // call this function on every dragend event
                    // onend: function (event) {
                    //     console.log('moved')
                    // }
                });
            if (this.resizable) {
                let edges = this.edges ? this.edges : { 
                    left: true,
                    right: true,
                    bottom: true,
                }
                this.interactable.resizable({
                    // resize from all edges and corners
                    edges,
                    listeners: {
                        move: (event) => {
                            const target = event.target
                            let x = (parseFloat(target.getAttribute('data-x')) || 0)
                            let y = (parseFloat(target.getAttribute('data-y')) || 0)

                            // update the element's style
                            target.style.width = event.rect.width + 'px'
                            target.style.height = event.rect.height + 'px'

                            // translate when resizing from top or left edges
                            x += event.deltaRect.left
                            y += event.deltaRect.top

                            this.setCoordinates(target, x, y);

                            target.setAttribute('data-x', x)
                            target.setAttribute('data-y', y)
                        }
                    },
                    modifiers: [
                        // minimum size
                        interact.modifiers.restrictSize({
                            min: this.minSize
                        })
                    ],
                })
            }
            // this is used later in the resizing and gesture demos
            window.dragMoveListener = this.dragMoveListener.bind(this);
        } catch (e) {
            console.log(e)
        }
    }

    dragMoveListener(event) {
        const target = event.target,
            // keep the dragged position in the data-x/data-y attributes
            x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
            y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        // translate the element
        this.setCoordinates(target, x, y);
        // update the posiion attributes
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    get initialPosition() {
        return this.state.initialPosition
    }

    set initialPosition(v) {
        const [x, y] = v
        this.state.initialPosition = v
        this.element.setAttribute('data-x', x)
        this.element.setAttribute('data-y', y)
        this.setCoordinates(this.element, x, y);
    }

    setCoordinates(target, x, y) {
        target.style.left = `${x}px`;
        target.style.top = `${y}px`;
    }

    destroy() {
        if (this.interactable) {
            this.interactable.unset();
            this.interactable = null;
        }

        if (this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
        }
    }

    resetSize() {
        this.element.style.width = "unset";
        this.element.style.height = "unset";
        setTimeout(() => {
            const rect = this.element.getBoundingClientRect();
            const availableHeight = window.innerHeight - rect.top;
            const availableWidth = window.innerWidth - rect.left;

            let scrollHeight;
            let scrollWidth

            const uiModalElement = this.element.querySelector("ui-modal");
            if (uiModalElement) {
                scrollHeight = uiModalElement.scrollHeight;
                scrollWidth = uiModalElement.scrollWidth;
            } else {
                scrollHeight = this.element.scrollHeight;
                scrollWidth = this.element.scrollWidth;
            }

            this.element.style.width = `${Math.min(availableWidth, scrollWidth)}px`;
            this.element.style.height = `${Math.min(availableHeight, scrollHeight)}px`;
        })
    }
}